




























































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import api from "../../api/index";
import Box from "../components/Box.vue";
import Lists from "../components/Lists.vue";
import { Getter } from "vuex-class";
const moment = require("moment");

import Map from "../components/Map.vue";
import ConfirmModal from "../components/ConfirmModal.vue";
import GroupForm from "../components/forms/GroupForm.vue";
import GroupUsers from "../components/forms/GroupUsers.vue";
import {perPageOptions} from '@/constants/ListOptions'

@Component({
	components: {
		Box,
		Map,
		ConfirmModal,
    GroupForm,
    GroupUsers
	},
})
export default class CondominiumProfile extends Lists {
	condominium = {
		title: null,
	};

	mapIsOpen = true;

	accessPoints = [];

	loading = false;
	isUserProfileModalActive = false;

	groups = [];
	groupsWordSearched = "";
	groupsTotalPages = 0;
	groupsTotalResults = 0;
	groupsCurrentPage = 1;
  perPageOptions = perPageOptions
	perPage: number = Number(localStorage.getItem('resultsPerListPage')) || this.perPageOptions[0];
	editedGroup = {};
	deleteModalActive = false;
  groupFormActive: boolean = false
  groupUsersActive: boolean = false
	deleteGroupId = null;

	@Getter("admin") admin: any;

	async mounted() {
		api.setToken();
		await this.getCondominium();
    await this.getCondominiumAccessPoints();
    await this.getGroups();
		this.addCondominiumNameInBreadcrumb();
	}

	async getCondominium() {
		try {
			const res = await api.get(
				"bo/condominiums/" + this.$route.params.condominiumId
			);
			this.condominium = res.data;
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

	async getGroups(pageNumber?: number) {
		try {
			const res = await api.get(
				"bo/condominiums/" + this.$route.params.condominiumId + "/groups",
				{
					params: {
						page: pageNumber,
						per_page: this.perPage,
						keywords: this.groupsWordSearched,
						order: 'created_at',
						order_desc: true,
					},
				}
			);
			this.groupsTotalPages = parseInt(res.headers["x-pagination-total-pages"]);
			this.groupsCurrentPage = parseInt(res.headers["x-pagination-page"]);
			this.groupsTotalResults = parseInt(res.headers["x-pagination-total"]);
			this.groups = res.data;
		} catch (error) {
			if (error.response.status === 401) {
				console.log(error.response.status);
			}
		}
	}

	goToAccess(row: any) {
		const accessId = row.id;
		this.$router.push({ name: "accessProfile", params: { accessId } });
	}

	goToAccessPoint(id: any) {
		this.$router.push({
			name: "accessPointProfile",
			params: { accessPointId: id },
		});
	}

	editGroup(group) {
		this.editedGroup = group;
		this.openGroupForm();
	}

  editGroupUsers(group) {
    this.editedGroup = group
    this.openGroupUsers()
  }

	async destroyGroup() {
		try {
			await api.delete(
				"bo/condominiums/" +
					this.$route.params.condominiumId +
					"/groups/" +
					this.deleteGroupId
			);
			this.closeDeleteModal();
			this.getGroups();
		} catch (error) {
			console.log(error);
		}
	}

  handleFormSuccess(v) {
	  this.getGroups()
    if (!v) return
    this.editGroupUsers(v)
  }

	@Watch("perPage")
  @Watch("groupsWordSearched")
	updateGroupsResults() {
		this.getGroups();
	}

	async getCondominiumAccessPoints() {
		try {
			const res = await api.get(
				"bo/condominiums/" + this.$route.params.condominiumId + "/access_points"
			);
			this.accessPoints = res.data;
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

	openDeleteModal(groupId) {
		this.deleteGroupId = groupId;
		this.deleteModalActive = true;
	}

	closeDeleteModal() {
		this.deleteGroupId = null;
		this.deleteModalActive = false;
	}

  openGroupForm() {
	  this.groupFormActive = true
  }

  closeGroupForm() {
    this.editedGroup = {}
    this.groupFormActive = false;
  }

  openGroupUsers() {
    this.groupUsersActive = true
  }

  closeGroupUsers() {
    this.editedGroup = {}
    this.groupUsersActive = false;
  }

	addCondominiumNameInBreadcrumb() {
		if (!this.condominium.title) return;
		const crumb: any = document.querySelector(".breadcrumb .is-current");
		if (this.condominium && this.condominium.title)
			crumb.innerHTML = `${this.condominium.title}`;
	}
}
